import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#0a192f] text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-pink-600">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>
              Hi, I'm Kevin. Thanks for visiting my portfolio. Please take a
              look around!
            </p>
          </div>
          <div className="mt-4">
            <p>
              I am passionate about the world of technology and web development.
              I'm a good communicator with the ability to work in a team and
              solve problems under pressure. Also creative and eager to continue
              learning and improving my skills!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
